import { useSession } from "../../hooks/useSession";

export default function Header() {
  const { data: me } = useSession();
  return (
    <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
      <h1 className="text-sm font-semibold text-slate-600">Claude AI Usage Monitor</h1>
      {me && (
        <div className="flex items-center gap-3 text-sm">
          <span className="text-slate-700">{me.email}</span>
          <span className="rounded bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700">
            {me.role}
          </span>
          <form method="post" action="/api/v1/auth/google/logout">
            <button className="text-slate-500 hover:text-slate-900" type="submit">
              Sign out
            </button>
          </form>
        </div>
      )}
    </header>
  );
}
